<div class="dados-inscricao-container">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div class="field">
            <label for="tipoInscricao" class="font-semibold block mb-2">Tipo de Inscrição *</label>
            <p-select
                [appendTo]="'body'"
                id="tipoInscricao"
                formControlName="tipoInscricao"
                [options]="opcoesTipoInscricao()"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                [readonly]="!modoEdicao() || carregandoDominios()"
            />
        </div>

        <div class="field">
            <label for="situacao" class="font-semibold block mb-2">Situação *</label>
            <p-select
                [appendTo]="'body'"
                id="situacao"
                formControlName="situacao"
                [options]="opcoesSituacao()"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                [readonly]="!modoEdicao() || carregandoDominios()"
            />
        </div>
    </div>
</div>
